var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUsers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 1,
    y: 0.5,
    width: 59,
    height: 59,
    rx: 29.5,
    fill: "#3772FF",
    stroke: "#3772FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_284_42653)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.5 39V37C35.5 35.9391 35.0786 34.9217 34.3284 34.1716C33.5783 33.4214 32.5609 33 31.5 33H23.5C22.4391 33 21.4217 33.4214 20.6716 34.1716C19.9214 34.9217 19.5 35.9391 19.5 37V39",
    stroke: "#3772FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5 29C29.7091 29 31.5 27.2091 31.5 25C31.5 22.7909 29.7091 21 27.5 21C25.2909 21 23.5 22.7909 23.5 25C23.5 27.2091 25.2909 29 27.5 29Z",
    stroke: "#3772FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5 39V37C41.4993 36.1137 41.2044 35.2528 40.6614 34.5523C40.1184 33.8519 39.3581 33.3516 38.5 33.13",
    stroke: "#667080",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5 21.13C35.3604 21.3503 36.123 21.8507 36.6676 22.5523C37.2122 23.2539 37.5078 24.1168 37.5078 25.005C37.5078 25.8932 37.2122 26.7561 36.6676 27.4577C36.123 28.1593 35.3604 28.6597 34.5 28.88",
    stroke: "#667080",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_284_42653"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(18.5 18)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.e1f90e87d6cd9ae160b739865a7759b5.svg";
export { ForwardRef as ReactComponent };